import { createBehavior } from '@area17/a17-behaviors';
import lazyloading from '../twill-image';

const image = createBehavior(
  'image',
  {},
  {
    init() {
      // Declarative reset of twill-image
      // by wrapping all images in an image behavior
      lazyloading.reset();
    },
    destroy() {},
  }
);

export default image;
